import { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// @ts-expect-error not typed

// @ts-expect-error not typed
import { getSecurityTypes } from '../selectors/DocSelectors';

// @ts-expect-error not typed
import TryIt from '../../TryIt/components/TryIt';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Code from 'UIComponents/elements/Code';
import UITruncateString from 'UIComponents/text/UITruncateString';
import EndpointComp from '../../../components/endpoint/EndpointComp';
// @ts-expect-error not typed
import { renderAuthTypes } from '../utils/DocsUtils';
import { WEB_FONT_BOLD_WEIGHT, WEB_FONT_REGULAR_WEIGHT } from 'HubStyleTokens/misc';
import { TABLE_BORDER_COLOR, TABLE_HEADER_BACKGROUND_COLOR } from 'HubStyleTokens/theme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledPathContainer = styled.div.withConfig({
  displayName: "PathUrl__StyledPathContainer",
  componentId: "sc-1bvktr7-0"
})(["background-color:", ";border-width:1px 1px 0 1px;border-style:solid;border-color:", ";display:flex;flex-wrap:nowrap;justify-content:space-between;align-items:baseline;padding:8px;"], TABLE_HEADER_BACKGROUND_COLOR, TABLE_BORDER_COLOR);
const StyledMethod = styled.strong.withConfig({
  displayName: "PathUrl__StyledMethod",
  componentId: "sc-1bvktr7-1"
})(["font-size:1em;"]);
const StyledCode = styled(Code).withConfig({
  displayName: "PathUrl__StyledCode",
  componentId: "sc-1bvktr7-2"
})(["background-color:transparent;padding:0 12px 4px 12px;&&{font-weight:", ";}"], WEB_FONT_REGULAR_WEIGHT);
const StyledPath = styled.span.withConfig({
  displayName: "PathUrl__StyledPath",
  componentId: "sc-1bvktr7-3"
})(["font-weight:", ";"], WEB_FONT_BOLD_WEIGHT);

/**
 * Wraps the scopes and "Test call" button group in the old layout.
 * @see https://app.hubspotqa.com/developer-docs/api?spec=v1/apis/cms/v3/hubdb
 */
const TryItWrapper = styled.div.withConfig({
  displayName: "PathUrl__TryItWrapper",
  componentId: "sc-1bvktr7-4"
})(["min-width:100px;margin-left:24px;"]);
class PathUrl extends Component {
  renderMethod() {
    const {
      operation
    } = this.props;
    return /*#__PURE__*/_jsx(StyledMethod, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `developer-docs-shared-components.methods.${operation.method}`
      })
    });
  }
  renderOldLayout() {
    const {
      doc,
      oas,
      oasDocs,
      operation,
      isMultipart,
      securityTypes,
      usageTracker
    } = this.props;
    return /*#__PURE__*/_jsxs(StyledPathContainer, {
      className: "path-container",
      children: [oas.servers && oas.servers.length > 0 && /*#__PURE__*/_jsxs("div", {
        className: "flex-no-wrap align-center",
        children: [this.renderMethod(), /*#__PURE__*/_jsx(StyledCode, {
          children: /*#__PURE__*/_jsx(StyledPath, {
            children: /*#__PURE__*/_jsx(UITruncateString, {
              reverse: true,
              children: operation.path
            })
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex-no-wrap align-center",
        children: [renderAuthTypes(securityTypes, false), /*#__PURE__*/_jsx(TryItWrapper, {
          children: /*#__PURE__*/_jsx(TryIt, {
            docId: doc._id,
            oasDocs: oasDocs,
            securityTypes: securityTypes,
            isMultipart: isMultipart,
            usageTracker: usageTracker
          })
        })]
      })]
    });
  }
  renderNewLayout() {
    const {
      oas,
      operation
    } = this.props;
    return /*#__PURE__*/_jsx(_Fragment, {
      children: oas.servers && oas.servers.length > 0 && /*#__PURE__*/_jsx(EndpointComp, {
        method: operation.method,
        path: operation.path
      })
    });
  }
  render() {
    const {
      newLayout
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "path-container",
      children: newLayout ? this.renderNewLayout() : this.renderOldLayout()
    });
  }
}
const select = (state, ownProps) => ({
  securityTypes: getSecurityTypes(state, ownProps).sort().reverse()
});
export default connect(select)(PathUrl);